module.exports = "/_next/static/images/d9b16006a893441bb52c04288e2cadf8-movie-poster.png.webp";